import { ReportingApiQueryFailed } from "../../../errors";
import axios from "axios";
/**
 * Client for looker-gateway's reporting API, reached through edge at
 * `/looker/v1/query/*`.
 *
 * One client for every module that queries this prefix: they share its auth,
 * its paths and its failure body.
 *
 * Authorization is not set here — `authentication.addAuthorizationHeader()`
 * installs a global axios request interceptor that stamps the bearer token on
 * every request the SDK makes.
 */
export class ReportingApiHandler {
    constructor(sdk) {
        this.sdk = sdk;
    }
    /**
     * @param path: the endpoint below `/query`, e.g. `/attribution/linear`.
     * @param body: the request body, already in the API's published names.
     * @param context: what failed, for the error message. e.g. "Failed to fetch
     * attribution data."
     */
    async query(path, body, context) {
        const url = `${this.sdk.urls.lookerGatewayBaseUrl}/query${path}`;
        try {
            const response = await axios.post(url, body);
            return response.data;
        }
        catch (error) {
            throw new ReportingApiQueryFailed(error, context);
        }
    }
}
//# sourceMappingURL=index.js.map